import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getPlatformClass } from '../../utils/platformUtils';
import './InventoryBackButton.css';

const InventoryBackButton = ({ 
  className = '', 
  style = {},
  onClick,
  children,
  ...props 
}) => {
  const navigate = useNavigate();
  const platformClass = getPlatformClass();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else {
      // Default behavior: go back to main orders page
      navigate('/orders');
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`inventory-back-nav ${platformClass} ${className}`}
      style={style}
      aria-label="Go back"
      {...props}
    >
      <span className="back-arrow">&lt;</span>
      <span className="back-text">{children}</span>
    </button>
  );
};

export default InventoryBackButton; 